import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Drawer from "../common/Drawer";
import styles from "./ProfileDrawers.module.css";
import * as billingService from "../../services/billingService";
import { usePermissions } from "../../hooks/usePermission";

const rand = (n) => `R${Number(n || 0).toLocaleString("en-ZA", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
const formatDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");

export default function BillingDrawer({ onClose }) {
  const navigate = useNavigate();
  const { canManageBilling } = usePermissions();
  const [sub, setSub] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    billingService.getSubscription().then(setSub).catch(() => setFailed(true));
  }, []);

  const { pricing = {} } = sub || {};
  const resources = sub?.totalResources ?? sub?.resourceCount;

  return (
    <Drawer title="Billing" onClose={onClose}>
      {failed && <p className={styles.muted}>Billing details could not be loaded.</p>}
      {!sub && !failed && <p className={styles.muted}>Loading…</p>}
      {sub && (
        <>
          <section className={styles.card}>
            <div className={styles.cardHead}>
              <strong>{sub.display_name || "Nodel"} subscription</strong>
              <span className={`${styles.pill} ${sub.status === "active" ? styles.pillGreen : ""}`}>{sub.is_trial_active ? "Trial" : sub.status}</span>
            </div>
            <span className={styles.label}>Your monthly cost</span>
            <div className={styles.price}>{rand(sub.amount)}</div>
            <div className={styles.line}><span>{sub.userCount} users × {rand(pricing.price_per_user)}</span><b>{rand(sub.userCount * pricing.price_per_user)}</b></div>
            <div className={styles.line}><span>{resources} resources × {rand(pricing.price_per_resource)}</span><b>{rand(resources * pricing.price_per_resource)}</b></div>
            {sub.appliedMinimum && <div className={styles.line}><span>Plan minimum applies</span><b>{rand(sub.minimum)}</b></div>}
            <div className={`${styles.line} ${styles.lineMuted}`}><span>Next payment</span><span>{formatDate(sub.current_period_end)}</span></div>
          </section>
          <section className={styles.card}>
            <div className={styles.cardHead}>
              <div><strong>PayFast</strong><div className={styles.muted}>Billed monthly in ZAR</div></div>
              {canManageBilling && (
                <button type="button" className={styles.button} onClick={() => { onClose(); navigate("/dashboard/settings?section=billing"); }}>Manage</button>
              )}
            </div>
          </section>
          <p className={styles.muted}>Seats update automatically when you add or archive people.</p>
        </>
      )}
    </Drawer>
  );
}
